import { useRecoilState } from "recoil";
import uiConfigAtom from "../atoms/uiConfigAtom";
import fontFamily from "../utils/fontFamily";


function Button({name, clickHandler, className}) {
    const [ uiConfig ] = useRecoilState(uiConfigAtom)

    const style = {
        backgroundColor: uiConfig?.button?.btnBgColor?.hex,
        color: uiConfig?.button?.btnFontColor?.hex,
        fontFamily: uiConfig?.button?.fontFamily,
        borderColor: uiConfig?.button?.btnBgColor?.hex,
    }

    return(
        <button 
            className={className || `font-semibold flex justify-center items-center text-white bg-custom-1 px-6 py-3 mb-2 rounded-md cursor-pointer text-${uiConfig?.button?.fontSize}`}
            onClick={() => clickHandler()}
            style={style}
        >
            {name}
        </button>
    )
}

export default Button;